import { render } from "./RecommendationList.vue?vue&type=template&id=cee33700&scoped=true"
import script from "./RecommendationList.vue?vue&type=script&lang=js"
export * from "./RecommendationList.vue?vue&type=script&lang=js"

import "./RecommendationList.vue?vue&type=style&index=0&id=cee33700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cee33700"]])

export default __exports__